var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.deepGet(_vm.form, 'config.content_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.content_page.form_title')) + " ")]) : _vm._e(), _vm.deepGet(_vm.form, 'config.content_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.form, 'config.content_page.form_desc')) + " ")]) : _vm._e(), _vm.showingManualCheckinForm ? _c('div', {
    staticClass: "page__content"
  }, [_c('ManualCheckinForm', {
    ref: "manualCheckinForm",
    on: {
      "submit": _vm.handleManualCheckinSubmit,
      "cancel": _vm.handleManualCheckinCancel
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "page__content"
  }, [_c('CheckinStatusDisplay', {
    attrs: {
      "message": _vm.content
    }
  })], 1), _c('CustomerProfile', {
    attrs: {
      "profile": _vm.profile,
      "user": _vm.user
    }
  }), _vm.showManualCheckinButton ? _c('SharedButton', {
    staticClass: "mt-4",
    attrs: {
      "variant": "s-btn-outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showingManualCheckinForm = true;
      }
    }
  }, [_vm._v(" 手動報到 ")]) : _vm._e(), _c('MemberButton', {
    staticClass: "mt-4",
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": "回 LINE OA",
      "type": "OA"
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }